import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@utils/api';
import '@moncler/scss/components/lookbook-genius/lookbook-genius.scss';
import ProductImage from '@moncler/components/product/ProductImage';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import classNames from 'classnames';
import Lazyimg from '@components/utils/Lazyimg';
import AOS from 'aos';
import { debounce } from '@common/utils/functions';
const PromoModule = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const [componentData, setComponentData] = useState(null);
    const [products, setProducts] = useState(null);
    const [viewtypes, setViewtypes] = useState(null);
    const ref = useRef(null);
    const buttonRef = useRef(null);
    AOS.init();
    useEffect(() => {
        if (componentData) {
            const observer = new IntersectionObserver(debounce(() => {
                var _a;
                (_a = ScrollTrigger.getById('lookbook-genius')) === null || _a === void 0 ? void 0 : _a.refresh();
            }, 1000));
            const body = document.querySelector('body');
            observer.observe(body);
            return () => {
                observer.unobserve(body);
            };
        }
    }, [componentData]);
    useEffect(() => {
        if (componentData && ref.current && buttonRef.current) {
            const tl = gsap.timeline({ paused: true });
            tl.from(buttonRef.current, {
                opacity: 0,
                y: 30,
                ease: 'power2.out',
                duration: 0.5,
            });
            ScrollTrigger.create({
                trigger: ref.current,
                start: 'bottom bottom',
                onEnter: () => {
                    tl.play();
                },
                onLeaveBack: () => {
                    tl.reverse();
                },
                id: 'lookbook-genius',
            });
        }
    }, [componentData]);
    useEffect(() => {
        var _a;
        let pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a;
                let componentDataRes = (_a = data.regions[0].components) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
                let componentDataMerged = Object.assign(Object.assign({}, componentDataRes.data), { custom: componentDataRes.custom });
                setComponentData(componentDataMerged);
                console.log('componentDataMerged', componentDataMerged);
            });
        }
    }, []);
    useEffect(() => {
        if (componentData) {
            const multilinePids = componentData === null || componentData === void 0 ? void 0 : componentData.products_multiline;
            const pids = multilinePids === null || multilinePids === void 0 ? void 0 : multilinePids.split('\n');
            const cleanPids = pids.map((pid) => pid.split(';')[0]);
            const viewtypesArray = pids.map((pid) => (pid.split(';').length > 1 ? pid.split(';')[1] : 'X'));
            setViewtypes(viewtypesArray);
            if (cleanPids.length > 0) {
                api.getProductTiles(cleanPids).then((data) => {
                    setProducts(data);
                });
            }
        }
    }, [componentData]);
    if (!componentData) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "lookbook-module" },
        React.createElement("div", { className: "lookbook-module_main" },
            React.createElement("div", { className: "lookbook-module_image-section" },
                React.createElement("picture", null,
                    React.createElement("source", { media: "(max-width: 768px)", srcSet: (_a = componentData.custom) === null || _a === void 0 ? void 0 : _a.mobileImage.src }),
                    React.createElement(Lazyimg, { src: (_b = componentData.custom) === null || _b === void 0 ? void 0 : _b.desktopImage.src, alt: '' }))),
            React.createElement("div", { className: "lookbook-module_products-section" },
                React.createElement("div", { className: "lookbook-module_products-section_intro", ref: ref },
                    React.createElement("h2", null, componentData.title),
                    React.createElement("p", null, componentData.description)),
                React.createElement("div", { className: "lookbook-module_products-section_products-grid" }, products === null || products === void 0 ? void 0 : products.map((product, i) => (React.createElement(ProductImage, { key: i, productId: product.id, img: product.imgs, type: viewtypes[i], className: "product-tile__image" })))))),
        componentData.cta_link && componentData.cta && (React.createElement("div", { className: "lookbook-module_cta-section", ref: buttonRef },
            React.createElement("a", { href: componentData.cta_link, className: classNames('button', 'button--primary-inverted') }, componentData.cta)))));
};
export default PromoModule;
